import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled, { StyledFunction } from 'styled-components';

import { toCSS } from '../../helpers/styles';
import { ButtonArrayDict, ButtonItemDict } from '../../types/TouchPanelDefs.js';
import Button from './Button';

interface IButtonPanelProps {
  hSpacing: number | string; //horizontal spacing between buttons in the panel
  vSpacing: number | string; //vertical spacing between buttons in the panel
  padding: number | string; //padding of the panel
  x: number | string; // absolute x position of the panel
  y: number | string; // absolute y position of the panel
  visible: string; //display the panel or hide
  buttonArrayRefs: Array<string>; //button panel references to show in the panel
  displayPanel?: boolean;
  height?: number | string; //height of the panel, generally not provided
  width?: number | string; //width the panel, generally not provided

  btnArrayDict: ButtonArrayDict;
  btnDict: ButtonItemDict;
  playSound: any;
  id: string;
}

const ButtonRow = styled.div<Partial<IButtonPanelProps>>`
  display: flex;
  ${({ vSpacing }) => `
        margin: ${toCSS(vSpacing)} 0px;
    `}
`;

const ButtonContainer = styled.div<IButtonPanelProps>`
  position: absolute;
  box-sizing: border-box;
  border: 1px solid #aaa;
  border-radius: 3px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;

  ${({ x, y, padding, displayPanel, height, width }) => `
        padding: ${toCSS(padding)};
        top: ${toCSS(y)};
        left: ${toCSS(x)};
        display: ${displayPanel ? 'inline-block' : 'none'};
        height: ${toCSS(height)};
        width: ${toCSS(width)};
        
    `}
`;

const TextContainer = styled.div`
  margin: 12px;
`;

const ButtonPanel: React.FunctionComponent<IButtonPanelProps> = props => {
  const { buttonArrayRefs, hSpacing, visible, playSound, id } = props;
  const [touchPanelDisplayText, setTouchPanelDisplayText] = useState('');
  const storeVisibility = useSelector(
    (state: any) => state.executor.touchPanelVisibility
  );
  const touchPanelText = useSelector(
    (state: any) => state.executor.touchPanelText
  );
  const [panelVisbiilty, setPanelVisibility] = useState(visible === 'true');
  useEffect(() => {
    const currPanelVisibility = storeVisibility[id];
    if (currPanelVisibility === undefined) {
      setPanelVisibility(visible === 'true');
    } else {
      setPanelVisibility(currPanelVisibility);
    }
  }, [storeVisibility]);

  useEffect(() => {
    if (touchPanelText && touchPanelText[id]) {
      console.log(
        '[ButtonPanel] ',
        touchPanelText[id],
        touchPanelText[id].split('\n').join('<br/>')
      );
      setTouchPanelDisplayText(
        touchPanelText[id].split('\\n').join('<br/><br/>')
      );
    } else {
      setTouchPanelDisplayText('');
    }
  }, [touchPanelText, id]);

  return (
    <ButtonContainer
      className="btn-panel"
      {...props}
      displayPanel={panelVisbiilty}
    >
      {touchPanelText[id] && (
        <TextContainer
          dangerouslySetInnerHTML={{
            ['__html']: touchPanelDisplayText,
          }}
        />
      )}
      {!touchPanelText[id] && (
        <React.Fragment>
          {buttonArrayRefs.map((btnRef, index) => {
            const buttonArray = props.btnArrayDict[btnRef];
            return (
              <ButtonRow
                className="btn-array"
                vSpacing={buttonArray.vSpacing}
                id={buttonArray.id}
                key={`${btnRef}_${index}`}
              >
                {buttonArray.buttonRefs.map((bRef, i) => {
                  const buttonRef = props.btnDict[bRef];
                  return (
                    <Button
                      playSound={playSound}
                      key={`${buttonRef.id}_${i}`}
                      hSpacing={hSpacing}
                      {...buttonRef}
                    ></Button>
                  );
                })}
              </ButtonRow>
            );
          })}
        </React.Fragment>
      )}
    </ButtonContainer>
  );
};

export default ButtonPanel;
